<script setup>
import { calendarWeeks } from '../helpers/DatePickerHelper';
import { computed } from 'vue';
import { formatLocalizedDate, getDateLocale } from 'shared/helpers/dateLocale';

const weekLabels = computed(() =>
  calendarWeeks.map(day => ({
    ...day,
    label: getDateLocale().code.startsWith('ar')
      ? formatLocalizedDate(new Date(2024, 0, day.id), 'EEEEE')
      : day.label,
  }))
);
</script>

<template>
  <div class="w-full max-w-md mx-auto grid grid-cols-7 gap-1">
    <div
      v-for="day in weekLabels"
      :key="day.id"
      class="flex items-center justify-center font-medium text-xs w-full min-w-0 h-7 py-1.5"
    >
      {{ day.label }}
    </div>
  </div>
</template>
